// extracted by mini-css-extract-plugin
module.exports = {"mainReviewsWrapper":"Xd-z"};